/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.75 18.25c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3Zm3-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4.75 4a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0V4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 2.75C0 1.2312 1.2312 0 2.75 0h6c1.5188 0 2.75 1.2312 2.75 2.75v1.6893l2.3055-2.3054c1.0739-1.074 2.8151-1.074 3.889 0l4.2427 4.2426c1.0739 1.074 1.0739 2.8152 0 3.8891L19.7028 12.5h1.5511c1.5188 0 2.75 1.2312 2.75 2.75v6c0 1.5188-1.2312 2.75-2.75 2.75H5.5v-.0053C2.4404 23.8638 0 21.3419 0 18.25V2.75ZM9.7028 22.5h11.5511c.6904 0 1.25-.5596 1.25-1.25v-6c0-.6904-.5596-1.25-1.25-1.25h-3.0511l-8.5 8.5Zm-3.9528 0c2.3472 0 4.25-1.9028 4.25-4.25V2.75c0-.6904-.5596-1.25-1.25-1.25h-6c-.6904 0-1.25.5596-1.25 1.25v15.5c0 2.3472 1.9028 4.25 4.25 4.25ZM11.5 6.5607l3.3661-3.3662c.4882-.4881 1.2796-.4881 1.7678 0l4.2426 4.2427c.4882.4881.4882 1.2796 0 1.7678L11.49 18.5913c.0066-.1129.01-.2268.01-.3414V6.5607Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuDevportalTheme'
);
